export const PATIENT_STATUSES = [
    "pending",
    "active",
    "inactive",
    "archived",
];
export function isPatientStatus(value) {
    return PATIENT_STATUSES.includes(value);
}
